/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { EnvironmentQuery } from "~/generated/graphql";
import { isNotNil } from "~/tools";

export function getNumFromString(input: string | null | undefined) {
  return Number(input) || 0;
}

export function mapEnvironmentData(
  environmentData: EnvironmentQuery | undefined
) {
  const contacts = (environmentData?.environment?.contacts ?? []).filter(
    isNotNil
  );

  return {
    nid: environmentData?.environment?.id || "",
    name: environmentData?.environment?.name || "",
    ownerId: environmentData?.environment?.owner?.id || "",
    description: environmentData?.environment?.description || "",
    contactIds: contacts.map((contact) => contact.id),
  };
}
